<!-- nlc-style Confirmation Dialog -->
<div class="nlc-dialog-header">
  <div class="dialog-icon-wrapper warning">
    <mat-icon class="dialog-icon">warning</mat-icon>
  </div>
  <h2 class="nlc-heading-3" mat-dialog-title>Coins verwenden?</h2>
</div>

<mat-dialog-content class="nlc-dialog-content">
  <div class="confirmation-message">
    <p class="nlc-body">
      Möchten Sie <span class="coins-highlight">{{ data.coins }} Coins</span> für diesen Auftrag wirklich verwenden?
    </p>
    <div class="nlc-warning-card">
      <mat-icon class="warning-icon">info</mat-icon>
      <p class="nlc-body-small">
        <strong>Hinweis:</strong> Diese Aktion kann nicht rückgängig gemacht oder geändert werden.
      </p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="nlc-dialog-actions">
  <button class="nlc-button nlc-button-text" (click)="cancel()">
    <mat-icon>close</mat-icon>
    Abbrechen
  </button>
  <button
    class="nlc-button nlc-button-primary"
    (click)="useCoins()"
    cdkFocusInitial>
    <mat-icon>check_circle</mat-icon>
    Verwenden
  </button>
</mat-dialog-actions>
